define('specific/header/models/HeaderModel', [

], function() {

    var HeaderModel = Backbone.Model.extend({
        defaults: {
            "type": "header",
            "viewId": "header",
            "isReady": false
        }
    });

    return HeaderModel;
});
